import styled from 'styled-components';

export const SelectButton = styled.div`
  font-family: ${props => props.theme.fonts.bold};
  font-size: 14px;
  color: #542785;
  cursor: pointer;
`;
